"use client"

import React from "react";
import { FormattedMessage } from 'react-intl';
import Image from "next/image";

import TestimonialOne from "@/assets/images/media/testimonial-one.png";
import TestimonialTwo from "@/assets/images/media/testimonial-two.png";
import TestimonialTree from "@/assets/images/media/testimonial-tree.png";
import TestimonialFour from "@/assets/images/media/testimonial-four.png";

const Testimonials = () => (
  <section id="testimonials" className="relative z-10 pt-[110px] pb-[60px]">
    <div className="container">
      <div className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]" data-wow-delay=".2s">
        <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
          <FormattedMessage
            id="home-page-testimonial-title"
          />
        </h2>
        <p className="text-base text-body">
          <FormattedMessage
            id="home-page-testimonial-description"
          />
        </p>
      </div>
    </div>

    <div className="container overflow-hidden lg:max-w-[1160px]">
      <div className="flex flex-wrap -mx-6">
        <div className="w-full px-6 lg:w-1/2">
          <div className="wow fadeInUp mb-[50px] rounded-lg bg-white py-9 px-7 shadow-card dark:bg-dark dark:shadow-card-dark sm:px-9 lg:px-7 xl:px-9" data-wow-delay=".2s">
            <div className="mb-5 border-b border-stroke dark:border-stroke-dark">
              <p className="text-base pb-9 text-body">
                &quot;<FormattedMessage
                  id="home-page-testimonial-one-description"
                />&quot;
              </p>
            </div>

            <div className="items-center justify-between sm:flex lg:block xl:flex">
              <div className="flex items-center mb-4 sm:mb-0 lg:mb-4 xl:mb-0">
                <div className="mr-4 h-[56px] w-full max-w-[56px] rounded-full">
                  <Image
                    src={TestimonialOne}
                    width={300}
                    height={300}
                    alt="Review of a Cozy Cafe Owner about Downfor"
                    title="Review of a Cozy Cafe Owner about Downfor"
                    className="inline-block size-6 rounded-full object-cover object-center w-full h-full"
                  />
                </div>
                <div>
                  <h3 className="text-base font-medium text-black dark:text-white">
                    <FormattedMessage
                      id="home-page-testimonial-one-reviewer"
                    />
                  </h3>
                  <p className="text-sm text-body">
                    <FormattedMessage
                      id="home-page-testimonial-one-designation"
                    />
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 sm:justify-end lg:justify-start xl:justify-end">
                <p className="text-base font-medium text-black dark:text-white">5.0</p>
                <div className="flex items-center space-x-[6px]">
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-6 lg:w-1/2">
          <div className="wow fadeInUp mb-[50px] rounded-lg bg-white py-9 px-7 shadow-card dark:bg-dark dark:shadow-card-dark sm:px-9 lg:px-7 xl:px-9" data-wow-delay=".3s">
            <div className="mb-5 border-b border-stroke dark:border-stroke-dark">
              <p className="text-base pb-9 text-body">
                &quot;<FormattedMessage
                  id="home-page-testimonial-two-description"
                />&quot;
              </p>
            </div>

            <div className="items-center justify-between sm:flex lg:block xl:flex">
              <div className="flex items-center mb-4 sm:mb-0 lg:mb-4 xl:mb-0">
                <div className="mr-4 h-[56px] w-full max-w-[56px] rounded-full">
                  <Image
                    src={TestimonialTwo}
                    width={300}
                    height={300}
                    title="Review of a Trendy Restaurant Manager about Downfor"
                    alt="Review of a Trendy Restaurant Manager about Downfor"
                    className="inline-block size-6 rounded-full object-cover object-center w-full h-full"
                  />
                </div>
                <div>
                  <h3 className="text-base font-medium text-black dark:text-white">
                    <FormattedMessage
                      id="home-page-testimonial-two-reviewer"
                    />
                  </h3>
                  <p className="text-sm text-body">
                    <FormattedMessage
                      id="home-page-testimonial-two-designation"
                    />
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 sm:justify-end lg:justify-start xl:justify-end">
                <p className="text-base font-medium text-black dark:text-white">5.0</p>
                <div className="flex items-center space-x-[6px]">
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-6 lg:w-1/2">
          <div className="wow fadeInUp mb-[50px] rounded-lg bg-white py-9 px-7 shadow-card dark:bg-dark dark:shadow-card-dark sm:px-9 lg:px-7 xl:px-9" data-wow-delay=".2s">
            <div className="mb-5 border-b border-stroke dark:border-stroke-dark">
              <p className="text-base pb-9 text-body">
                &quot;<FormattedMessage
                  id="home-page-testimonial-tree-description"
                />&quot;
              </p>
            </div>

            <div className="items-center justify-between sm:flex lg:block xl:flex">
              <div className="flex items-center mb-4 sm:mb-0 lg:mb-4 xl:mb-0">
                <div className="mr-4 h-[56px] w-full max-w-[56px] rounded-full">
                  <Image
                    src={TestimonialTree}
                    width={300}
                    height={300}
                    title="Review of a Boutique Hotel Owner about Downfor"
                    alt="Review of a Boutique Hotel Owner about Downfor"
                    className="inline-block size-6 rounded-full object-cover object-center w-full h-full"
                  />
                </div>
                <div>
                  <h3 className="text-base font-medium text-black dark:text-white">
                    <FormattedMessage
                      id="home-page-testimonial-tree-reviewer"
                    />
                  </h3>
                  <p className="text-sm text-body">
                    <FormattedMessage
                      id="home-page-testimonial-tree-designation"
                    />
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 sm:justify-end lg:justify-start xl:justify-end">
                <p className="text-base font-medium text-black dark:text-white">5.0</p>
                <div className="flex items-center space-x-[6px]">
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-6 lg:w-1/2">
          <div className="wow fadeInUp mb-[50px] rounded-lg bg-white py-9 px-7 shadow-card dark:bg-dark dark:shadow-card-dark sm:px-9 lg:px-7 xl:px-9" data-wow-delay=".3s">
            <div className="mb-5 border-b border-stroke dark:border-stroke-dark">
              <p className="text-base pb-9 text-body">
                &quot;<FormattedMessage
                  id="home-page-testimonial-four-description"
                />&quot;
              </p>
            </div>

            <div className="items-center justify-between sm:flex lg:block xl:flex">
              <div className="flex items-center mb-4 sm:mb-0 lg:mb-4 xl:mb-0">
                <div className="mr-4 h-[56px] w-full max-w-[56px] rounded-full">
                  <Image
                    src={TestimonialFour}
                    width={300}
                    height={300}
                    title="Review of a Freelance Photographer about Downfor"
                    alt="Review of a Freelance Photographer about Downfor"
                    className="inline-block size-6 rounded-full object-cover object-center w-full h-full"
                  />
                </div>
                <div>
                  <h3 className="text-base font-medium text-black dark:text-white">
                    <FormattedMessage
                      id="home-page-testimonial-four-reviewer"
                    />
                  </h3>
                  <p className="text-sm text-body">
                    <FormattedMessage
                      id="home-page-testimonial-four-designation"
                    />
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 sm:justify-end lg:justify-start xl:justify-end">
                <p className="text-base font-medium text-black dark:text-white">5.0</p>
                <div className="flex items-center space-x-[6px]">
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_49_480)">
                        <path
                          d="M10 15.2171L4.1225 18.5071L5.435 11.9004L0.489166 7.32712L7.17833 6.53378L10 0.417114L12.8217 6.53378L19.5108 7.32712L14.565 11.9004L15.8775 18.5071L10 15.2171Z"
                          fill="#EABF23"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_49_480">
                          <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Testimonials;